import LocationFinderContainer from './LocationFinderContainer';

export default LocationFinderContainer;
